import { css, keyframes } from '@emotion/react';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

const scaleIn = keyframes`
  0% {
    transform: scale(1.2) translateZ(0);
  }
  100% {
    transform: scale(1) translateZ(0);
  }
`;

const makeBrandMatchMessageStyling = ({ theme }) => {
  const primaryColor = theme.mvf.palette.primary?.main || '#5C2E91';
  const backgroundColor =
    theme.mvf.palette.background?.paper || 'rgba(92, 46, 145, 0.05)';
  const borderColor =
    theme.mvf.palette.primary?.light || 'rgba(92, 46, 145, 0.2)';

  return {
    container: css({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: theme.mvf.spacing.medium,
      marginBottom: theme.mvf.spacing.small,
      paddingLeft: theme.mvf.spacing.medium,
      paddingRight: theme.mvf.spacing.medium,
      width: '100%',
    }),

    card: css({
      display: 'flex',
      alignItems: 'center',
      backgroundColor,
      border: `1.5px solid ${borderColor}`,
      borderRadius: '12px',
      padding: `${theme.mvf.spacing.small} ${theme.mvf.spacing.medium}`,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
      width: '100%',
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      },
    }),

    contentWrapper: css({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      gap: theme.mvf.spacing.small,
    }),

    iconWrapper: css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: '20px',
      height: '20px',
    }),

    icon: css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: primaryColor,
    }),

    spinner: css({
      color: primaryColor,
    }),

    textWrapper: css({
      flex: 1,
    }),

    text: css({
      fontSize: theme.mvf.fontSize.small,
      fontWeight: theme.mvf.typography.weight.medium,
      color: theme.mvf.palette.text.primary,
      lineHeight: 1.5,
      fontFamily: theme.mvf.typography.fontFamily,
      margin: 0,
      animation: `${pulse} 0.5s ease-in-out`,
    }),

    count: css({
      fontWeight: theme.mvf.typography.weight.thick,
      color: primaryColor,
      fontSize: theme.mvf.fontSize.medium,
      display: 'inline-block',
      transform: 'scale(1) translateZ(0)',
      willChange: 'transform',
      backfaceVisibility: 'hidden',
      animation: `${scaleIn} 0.5s ease-out`,
    }),
  };
};

export default makeBrandMatchMessageStyling;
